module.exports = __webpack_public_path__ + "img/GoDown.84398e4.png";